import { toast } from "react-toastify";
import {
  SET_LOADING,
  IS_APP_LOCKED,
  WAS_USER_NOTIFIED,
  RESET_GLOBAL,
} from "./../actions/types";
import httpService from "../../components/services/httpService";
import config from "../../config.json";

export const setUnloading = () => {
  return {
    type: SET_LOADING,
    payload: false,
  };
};
export const setLoading = () => {
  return {
    type: SET_LOADING,
    payload: true,
  };
};

export const isAppLocked = () => (dispatch, getState) => {
  var isLocked = false;
  const url = config.endPoints.consultaBloqueoSistema;
  httpService
    .get(url)
    .then(({ data }) => {
      dispatch({
        type: IS_APP_LOCKED,
        payload: Boolean(data.estaBloqueado),
      });
    })
    .catch((error) => {
      console.error("Error al consultar bloqueo de sistema: ", error);
    });
};

export const wasUserNotified = (wasNotified) => {
  return {
    type: WAS_USER_NOTIFIED,
    payload: wasNotified,
  };
};

export const resetGlobal = () => {
  return {
    type: RESET_GLOBAL,
  };
};
